import { SupportedLanguageCodes } from '@ph-static-data/languages';

import { ClientConfigImages } from './client-config-images.model';
import { ClientInfoI18n } from './client-info-i18n.model';
import { ClientInfo } from './client-info.model';

export class ClientConfigResponse {
  status: string | null = null;
  captcha: {
    data: string | null;
    text: string | null;
    required: boolean | null;
    encText: string | null;
  };
  captchaRequired: boolean;
  programName: string | null = null;
  isProgramSSO: string | null = null;
  programMake: string | null = null;
  userSSOSuffix: string | null = null;
  programId: string | null = null;
  clientInfo: ClientInfo | null = null;
  clientInfo_i18n: ClientInfoI18n[] | null = null;
  applicationId: string | null = null;
  loginBox: {
    boldTitle: boolean | null;
    leftJustify: boolean | null;
  };
  multilingual: string | null = null;
  leftJustify: boolean | null = null;
  languageCode: SupportedLanguageCodes | null = null;
  css: {
    logoBkgrdColor: string | null;
    primaryColor: string | null;
    secondaryColor: string | null;
    brandBarColor: string | null;
    fontColor: string | null;
    buttonColor: string | null;
  };
  images: ClientConfigImages | null;
  imageIds: {
    imageName: string;
    imageId: string;
    image: string;
  }[];
  languages: { name: string; code: SupportedLanguageCodes }[] = [];
  message?: string;

  constructor() {
    this.images = new ClientConfigImages();
    this.captcha = {
      data: null,
      text: null,
      required: null,
      encText: null,
    };
    this.loginBox = {
      boldTitle: null,
      leftJustify: null,
    };
    this.css = {
      logoBkgrdColor: null,
      primaryColor: null,
      secondaryColor: null,
      brandBarColor: null,
      fontColor: null,
      buttonColor: null,
    };
    this.captchaRequired = false;
    this.imageIds = [];
  }
}
